var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 22,
    viewBox: "0 0 8 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 22,
    rx: 4,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.5C6 5.60938 5.10156 6.5 4 6.5C2.89062 6.5 2 5.60938 2 4.5C2 3.39844 2.89062 2.5 4 2.5C5.10156 2.5 6 3.39844 6 4.5Z",
    fill: "#1956A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.5C6 12.6094 5.10156 13.5 4 13.5C2.89062 13.5 2 12.6094 2 11.5C2 10.3984 2.89062 9.5 4 9.5C5.10156 9.5 6 10.3984 6 11.5Z",
    fill: "#1956A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.5C6 19.6094 5.10156 20.5 4 20.5C2.89062 20.5 2 19.6094 2 18.5C2 17.3984 2.89062 16.5 4 16.5C5.10156 16.5 6 17.3984 6 18.5Z",
    fill: "#1956A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon_more.4034a95619d6ef5a2e63c0dc98530268.svg";
export { ForwardRef as ReactComponent };